import { css } from "@emotion/css";

import { grey, white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createEmptyListStyles = ({ borderRadius, spacing }: Theme) => {
  return {
    root: css({
      position: "absolute",
      left: "50%",
      top: "30%",
      transform: "translateX(-50%)",
      backgroundColor: white,
      border: `1px solid ${grey[200]}`,
      borderRadius: borderRadius.medium,
      width: "80%",
      maxWidth: 360,
      padding: spacing(3),
    }),
    heading: css({
      margin: spacing([0, 0, 2]),
      textAlign: "center",
    }),
    contentWrapper: css({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }),
  };
};
